import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { HeaderBreadcrumbs } from '../Breadcrumbs';

export const CollapsibleSubNavBreadcrumbs = Styled(HeaderBreadcrumbs)`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  flex: 1;
  padding: 0;
  border-top: none;
  height: 100%;

  /* overrides media query on HeaderBreadcrumbs */
  ${media.medium`
    padding: 0;
    display: flex;
  `}
`;
